import axios from "axios";
import { getBearerToken } from "./user.service";

export const createAxiosClient = (baseURL: string) => {
  const client = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  client.interceptors.request.use(
    async (config: any) => {
      console.log("Intercepting");
      try {
        const token = await getBearerToken();
        if (token) {
          config.headers = {
            ...config.headers,
            Authorization: token, // make sure "Bearer " is included
          };
        }
      } catch (e) {
        console.log("Error getting token:");
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  return client;
};

export const axiosClient = createAxiosClient(process.env.REACT_APP_API_URL!);
export const axiosAgentClient = createAxiosClient(
  process.env.REACT_APP_AGENT_API_URL!,
);
